import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";

const CONVERSATIONS_PAGE_SIZE = 20;

export const useAskNobiChatQueries = () => {
  const api = useApi();

  return {
    list: () =>
      infiniteQueryOptions({
        queryKey: QUERY_KEYS.ASSISTANT_CONVERSATIONS_LIST(),
        queryFn: ({ pageParam = 0 }) =>
          api
            .getAssistantConversationsV1({
              Offset: pageParam * CONVERSATIONS_PAGE_SIZE,
              Limit: CONVERSATIONS_PAGE_SIZE,
            })
            .then((x) => commonAPIDataSelector(x)),
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => (lastPage?.hasMore ? pages.length : undefined),
      }),
    details: (conversationId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.ASSISTANT_CONVERSATION(conversationId),
        queryFn: () => api.getAssistantConversationsDetailsV1(conversationId),
        select: commonAPIDataSelector,
      }),
    conversationMessages: (conversationId: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.ASSISTANT_CONVERSATION_MESSAGES(conversationId),
        queryFn: () => api.getAssistantConversationsMessagesV1(conversationId),
        select: commonAPIDataSelector,
      }),
  };
};
